import React from 'react';
import { useTranslation } from 'utils/i18n';

const Logo = ({ 
  showTagline = true, 
  showVerticalLine = true, 
  className = '',
  taglineClassName = '',
  logoClassName = '',
  size = 'default', // 'default', 'small', 'large'
  reversed = false // Color reversed mode
}) => {
  const { t } = useTranslation();

  const sizeClasses = {
    small: {
      logo: 'bsp-logo-wrapper-small',
      text: 'bsp-logo-text-small',
      circle: 'bsp-logo-circle-small',
      letter: 'bsp-logo-letter-small',
      tagline: 'bsp-tagline-small'
    },
    default: {
      logo: 'bsp-logo-wrapper',
      text: 'bsp-logo-text',
      circle: 'bsp-logo-circle',
      letter: 'bsp-logo-letter',
      tagline: 'bsp-tagline'
    },
    large: {
      logo: 'bsp-logo-wrapper-large',
      text: 'bsp-logo-text-large',
      circle: 'bsp-logo-circle-large',
      letter: 'bsp-logo-letter-large',
      tagline: 'bsp-tagline-large'
    }
  };

  const classes = sizeClasses[size];
  const reversedClass = reversed ? 'bsp-logo-reversed' : '';

  return (
    <div className={`bsp-logo-container ${className} ${reversedClass}`}>
      <div className={classes.logo}>
        <div className={`${classes.circle} ${reversedClass}`}>
          <span className={classes.letter}>B</span>
        </div>
        <span className={`${classes.text} ${reversedClass}`}>esper</span>
      </div>
      
      {showTagline && (
        <div className={`bsp-tagline-wrapper ${taglineClassName}`}>
          {showVerticalLine && <div className="bsp-tagline-line"></div>}
          <div className={`bsp-tagline ${classes.tagline} ${logoClassName}`}>
            <span 
              className="bsp-tagline-highlight"
              dangerouslySetInnerHTML={{ __html: t('header.tagline', 'Communication Infrastructure<br />Made Simple') }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Logo;
